(function () {
  'use strict';

  var ukTimeFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  function getUkTimeParts() {
    var parts = {};

    ukTimeFormatter.formatToParts(new Date()).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = part.value;
    });

    return {
      weekday: parts.weekday,
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second)
    };
  }

  function formatRemaining(totalSeconds) {
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);

    if (hours > 0) {
      return hours + ' hr' + (hours === 1 ? '' : 's') + ' ' + minutes + ' min';
    }

    return Math.max(1, minutes) + ' min';
  }

  function getMessage() {
    var now = getUkTimeParts();
    var isWeekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(now.weekday) !== -1;
    var secondsSinceMidnight = (now.hour * 3600) + (now.minute * 60) + now.second;
    var cutoffSeconds = 14 * 3600;

    if (isWeekday && secondsSinceMidnight < cutoffSeconds) {
      return 'Order within ' + formatRemaining(cutoffSeconds - secondsSinceMidnight) + ' for same-day dispatch';
    }

    return 'Order now for dispatch the next working day';
  }

  function update(root) {
    var message = root.querySelector('[data-dispatch-countdown-message]');
    if (message) message.textContent = getMessage();
  }

  function initialise(root) {
    if (!root || root.dataset.dispatchCountdownBound === 'true') return;

    root.dataset.dispatchCountdownBound = 'true';
    update(root);
    window.setInterval(function () { update(root); }, 30000);
  }

  function initialiseAll(container) {
    (container || document).querySelectorAll('[data-dispatch-countdown]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
